import { useState, useEffect } from 'react';

/**
 * A react hook that ties the open state of a feature like modal/secondary view to the back button
 * of the browser.  It conditionally pushes and pops state from the Browser History state based on
 * the open state.
 *
 * Returns a stateful value, and a function to update it.
 *
 * @param id Used as the id of the entry saved in browser history state and should be unique.
 */
function useBrowserHistoryModalOpenState(id) {
  const [isOpen, setIsOpen] = useState(false);
  function handlePopState(event) {
    if (!event.state || !event.state[id]) {
      setIsOpen(false);
    }
    if (event.state && event.state[id]) {
      setIsOpen(true);
    }
  }
  useEffect(() => {
    window.addEventListener('popstate', handlePopState);
    if (isOpen && (!window.history.state || !window.history.state[id])) {
      window.history.pushState({
        ...window.history.state,
        [id]: true
      }, '');
    }
    if (!isOpen && window.history.state && window.history.state[id]) {
      window.history.back();
    }
    return () => {
      window.removeEventListener('popstate', handlePopState);
      if (isOpen) {
        setIsOpen(false);
      }
    };
  }, [id, isOpen]);
  return [isOpen, setIsOpen];
}

export { useBrowserHistoryModalOpenState as u };
//# sourceMappingURL=useBrowserHistoryOpenState-BH9rP6L6-BH9rP6L6.js.map
